import { backendApi } from '../../config'

export type Request = {
  firstName: string
  lastName: string
  document: string
  email: string
  password: string
  phone: string
  image?: File
  categories?: string[]
  gender: string
  birthDate: string
  address: {
    country: string
    city: string
    state: string
    zipCode: string
    complement?: string
    district: string
    number: number
    street: string
  }
}

export type Response = {}

export const createCustomerService = async (data: Request) => {
  const formData = new FormData()

  // Formatar documento e telefone
  const formatedDocument = data.document.replace(/[^0-9]/g, '')
  const formatedPhone = data.phone.replace(/[^0-9]/g, '')

  // Adiciona os campos de texto
  formData.append('firstName', data.firstName)
  formData.append('lastName', data.lastName)
  formData.append('document', formatedDocument)
  formData.append('email', data.email)
  formData.append('password', data.password)
  formData.append('phone', formatedPhone)
  formData.append('gender', data.gender)
  formData.append('birthDate', data.birthDate)
  formData.append('address', JSON.stringify(data.address))

  if (data.categories) {
    formData.append('categories', JSON.stringify(data.categories))
  }

  if (data.image) {
    formData.append('image', data.image)
  }

  const response = await backendApi.post('/api/customers/v2', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return response.data
}
